import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex flex-row" }
const _hoisted_2 = { class: "flex cleopatra flex-col w-full" }
const _hoisted_3 = { class: "container flex gap-2 justify-between max-w-5xl mx-auto overflow-x-auto p-5 pb-3 xl:flex-row" }
const _hoisted_4 = { class: "flex gap-2 items-center" }
const _hoisted_5 = { class: "h1" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("svg", {
  width: "6",
  height: "10",
  viewBox: "0 0 6 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("line", {
    x1: "1",
    y1: "9.29289",
    x2: "5.29289",
    y2: "5",
    stroke: "#222B45",
    "stroke-linecap": "round"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "5.29289",
    y1: "5",
    x2: "1",
    y2: "0.707107",
    stroke: "#222B45",
    "stroke-linecap": "round"
  })
], -1)
const _hoisted_7 = { class: "h1" }
const _hoisted_8 = { class: "container flex gap-2 justify-between max-w-5xl mx-auto overflow-x-auto px-5 py-3" }
const _hoisted_9 = { class: "flex gap-2 cursor-pointer" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("svg", {
  width: "6",
  height: "10",
  viewBox: "0 0 6 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("line", {
    x1: "5",
    y1: "0.707107",
    x2: "0.707106",
    y2: "5",
    stroke: "#222B45",
    "stroke-linecap": "round"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "0.707107",
    y1: "5",
    x2: "5",
    y2: "9.29289",
    stroke: "#222B45",
    "stroke-linecap": "round"
  })
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "Back", -1)
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = { class: "container flex flex-col gap-2 max-w-5xl mx-auto overflow-x-auto p-5" }
const _hoisted_14 = { class: "box-details flex flex-col gap-4 p-5" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "bg-gray-100 h-[1px] mr-3 w-full" }),
  /*#__PURE__*/_createElementVNode("p", { class: "min-w-max text uppercase" }, "General"),
  /*#__PURE__*/_createElementVNode("div", { class: "bg-gray-100 h-[1px] ml-3 w-full" })
], -1)
const _hoisted_16 = { class: "flex flex-col gap-2 items-start justify-between sm:flex-row" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col w-full sm:w-4/12" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-title" }, "Product Name")
], -1)
const _hoisted_18 = { class: "flex flex-col items-end w-full sm:justify-end sm:w-8/12" }
const _hoisted_19 = { class: "flex flex-col gap-2 items-start justify-between sm:flex-row" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col w-full sm:w-4/12" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-title" }, "Product Category")
], -1)
const _hoisted_21 = { class: "flex flex-col items-end w-full sm:justify-end sm:w-8/12" }
const _hoisted_22 = { class: "flex flex-col gap-2 items-start justify-between sm:flex-row" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col w-full sm:w-4/12" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-title" }, "Ingredients")
], -1)
const _hoisted_24 = { class: "flex flex-col gap-1 items-end w-full sm:justify-end sm:w-8/12" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "pr-3 text-mini" }, " You can add multiple ingrediants ", -1)
const _hoisted_26 = { class: "flex flex-col gap-2" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "text-title" }, "Product Photo", -1)
const _hoisted_28 = { class: "flex flex-wrap gap-2" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("p", { class: "text-mini" }, " For now you can upload only one product photo. ", -1)
const _hoisted_30 = { class: "box-details flex flex-col gap-4 p-5" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "bg-gray-100 h-[1px] mr-3 w-full" }),
  /*#__PURE__*/_createElementVNode("p", { class: "min-w-max text uppercase" }, "Options"),
  /*#__PURE__*/_createElementVNode("div", { class: "bg-gray-100 h-[1px] ml-3 w-full" })
], -1)
const _hoisted_32 = { class: "flex gap-5 w-full" }
const _hoisted_33 = { class: "flex gap-3 items-center" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", { class: "text-title" }, "Name", -1)
const _hoisted_35 = ["onUpdate:modelValue"]
const _hoisted_36 = { class: "flex gap-3 items-center" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", { class: "text-title" }, "Price", -1)
const _hoisted_38 = ["onUpdate:modelValue"]
const _hoisted_39 = ["onClick"]
const _hoisted_40 = /*#__PURE__*/_createElementVNode("svg", {
  width: "15",
  height: "16",
  viewBox: "0 0 15 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12.7869 6.08365C12.7869 6.08365 12.376 11.1806 12.1376 13.3277C12.0241 14.3531 11.3907 14.954 10.3531 14.9729C8.37863 15.0085 6.40189 15.0108 4.42817 14.9691C3.42996 14.9487 2.80712 14.3403 2.69587 13.333C2.45597 11.167 2.0473 6.08365 2.0473 6.08365",
    stroke: "#ED5151",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M13.8337 3.64039H1",
    stroke: "#ED5151",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M11.3609 3.64045C10.7669 3.64045 10.2553 3.22043 10.1387 2.63846L9.95483 1.7182C9.84131 1.29364 9.45686 1 9.01868 1H5.81517C5.37699 1 4.99254 1.29364 4.87902 1.7182L4.69512 2.63846C4.57857 3.22043 4.06698 3.64045 3.4729 3.64045",
    stroke: "#ED5151",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_41 = [
  _hoisted_40
]
const _hoisted_42 = { class: "box-details flex flex-col gap-4 p-5" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "bg-gray-100 h-[1px] mr-3 w-full" }),
  /*#__PURE__*/_createElementVNode("p", { class: "min-w-max text uppercase" }, "Extras"),
  /*#__PURE__*/_createElementVNode("div", { class: "bg-gray-100 h-[1px] ml-3 w-full" })
], -1)
const _hoisted_44 = { class: "flex gap-5 w-full" }
const _hoisted_45 = { class: "flex gap-3 items-center" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("span", { class: "text-title" }, "Name", -1)
const _hoisted_47 = ["onUpdate:modelValue"]
const _hoisted_48 = { class: "flex gap-3 items-center" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("span", { class: "text-title" }, "Price", -1)
const _hoisted_50 = ["onUpdate:modelValue"]
const _hoisted_51 = ["onClick"]
const _hoisted_52 = /*#__PURE__*/_createElementVNode("svg", {
  width: "15",
  height: "16",
  viewBox: "0 0 15 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12.7869 6.08365C12.7869 6.08365 12.376 11.1806 12.1376 13.3277C12.0241 14.3531 11.3907 14.954 10.3531 14.9729C8.37863 15.0085 6.40189 15.0108 4.42817 14.9691C3.42996 14.9487 2.80712 14.3403 2.69587 13.333C2.45597 11.167 2.0473 6.08365 2.0473 6.08365",
    stroke: "#ED5151",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M13.8337 3.64039H1",
    stroke: "#ED5151",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M11.3609 3.64045C10.7669 3.64045 10.2553 3.22043 10.1387 2.63846L9.95483 1.7182C9.84131 1.29364 9.45686 1 9.01868 1H5.81517C5.37699 1 4.99254 1.29364 4.87902 1.7182L4.69512 2.63846C4.57857 3.22043 4.06698 3.64045 3.4729 3.64045",
    stroke: "#ED5151",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_53 = [
  _hoisted_52
]
const _hoisted_54 = { class: "flex flex-col gap-4 p-5" }
const _hoisted_55 = { class: "flex justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_FileInputView = _resolveComponent("FileInputView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.Store.value?.name), 1),
          _hoisted_6,
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.editOn ? "Edit" : "Add") + " Product", 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", {
            class: "button-back cursor-pointer",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push(`/store/${_ctx.$route.params.id}`)))
          }, _hoisted_12)
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("div", _hoisted_18, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.item.name) = $event)),
                class: "input-style form-field w-full sm:w-72"
              }, null, 512), [
                [_vModelText, _ctx.item.name]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createElementVNode("div", _hoisted_21, [
              _createVNode(_component_AutoComplete, {
                modelValue: _ctx.product,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.product) = $event)),
                items: _ctx.productCategory,
                "track-by": "name",
                "show-by": "name",
                "filter-by": "name",
                "return-by": "'name'",
                placeholder: "Select product category"
              }, null, 8, ["modelValue", "items"])
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            _createElementVNode("div", _hoisted_24, [
              _createVNode(_component_AutoComplete, {
                modelValue: _ctx.submittedIngredients,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.submittedIngredients) = $event)),
                items: _ctx.ingredients,
                "track-by": "value",
                "show-by": "value",
                "filter-by": "value",
                "return-by": "'value'",
                placeholder: "Ingredients",
                onSubmit: _cache[4] || (_cache[4] = (val) => _ctx.addIngredient(val)),
                multiple: true
              }, null, 8, ["modelValue", "items"]),
              _hoisted_25
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _hoisted_27,
            _createElementVNode("div", _hoisted_28, [
              _createVNode(_component_FileInputView, {
                modelValue: _ctx.productImage,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.productImage) = $event)),
                rules: "image",
                "field-name": "image",
                "media-type": _ctx.MediaType.ITEM,
                onInput: _cache[6] || (_cache[6] = (image) => _ctx.productImageSubmitted(image)),
                entityId: _ctx.Store.id
              }, null, 8, ["modelValue", "media-type", "entityId"])
            ]),
            _hoisted_29
          ])
        ]),
        _createElementVNode("div", _hoisted_30, [
          _hoisted_31,
          _createElementVNode("div", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemOptions, (itemOptEx, idx) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "flex gap-2 items-center justify-between mb-4",
                key: idx
              }, [
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _hoisted_34,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": ($event: any) => ((itemOptEx.name) = $event),
                      type: "text",
                      class: "input-style form-field w-32 sm:w-72"
                    }, null, 8, _hoisted_35), [
                      [_vModelText, itemOptEx.name]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    _hoisted_37,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": ($event: any) => ((itemOptEx.price) = $event),
                      type: "number",
                      class: "input-style form-field w-24"
                    }, null, 8, _hoisted_38), [
                      [
                        _vModelText,
                        itemOptEx.price,
                        void 0,
                        { number: true }
                      ]
                    ])
                  ])
                ]),
                _createElementVNode("div", {
                  class: "flex flex-col items-end cursor-pointer",
                  onClick: () => _ctx.deleteOption(idx)
                }, _hoisted_41, 8, _hoisted_39)
              ]))
            }), 128)),
            _createElementVNode("span", {
              class: "text-small-link",
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.addOption && _ctx.addOption(...args)))
            }, " + Add Option ")
          ])
        ]),
        _createElementVNode("div", _hoisted_42, [
          _hoisted_43,
          _createElementVNode("div", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemExtras, (itemOptEx, idx) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "flex gap-2 items-center justify-between mb-4",
                key: idx
              }, [
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("div", _hoisted_45, [
                    _hoisted_46,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": ($event: any) => ((itemOptEx.name) = $event),
                      type: "text",
                      class: "input-style form-field w-32 sm:w-72"
                    }, null, 8, _hoisted_47), [
                      [_vModelText, itemOptEx.name]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_48, [
                    _hoisted_49,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": ($event: any) => ((itemOptEx.price) = $event),
                      type: "number",
                      class: "input-style form-field w-24"
                    }, null, 8, _hoisted_50), [
                      [
                        _vModelText,
                        itemOptEx.price,
                        void 0,
                        { number: true }
                      ]
                    ])
                  ])
                ]),
                _createElementVNode("div", {
                  class: "flex flex-col items-end cursor-pointer",
                  onClick: () => _ctx.deleteExtra(idx)
                }, _hoisted_53, 8, _hoisted_51)
              ]))
            }), 128)),
            _createElementVNode("span", {
              class: "text-small-link",
              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.addExtra && _ctx.addExtra(...args)))
            }, " + Add Extra ")
          ])
        ]),
        _createElementVNode("div", _hoisted_54, [
          _createElementVNode("div", _hoisted_55, [
            _createElementVNode("div", {
              class: "button",
              onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
            }, [
              _createElementVNode("span", null, _toDisplayString(!_ctx.itemId ? "Add" : "Update"), 1)
            ])
          ])
        ])
      ])
    ])
  ]))
}